import HtmlTrans from 'components/shared/HtmlTrans';
import { Heading2 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import {
  StyledAvailability,
  StyledAvailabilityGrid,
  StyledCardTitle,
  StyledContainer,
  StyledConversionsContent,
  StyledHeader,
  StyledLegend,
  StyledProgress,
  StyledProgressValue
} from './Candidates.styled';

const Conversions: React.FC = () => {
  const { t } = useI18n('state-of-hiring');

  const availabilityData = {
    available: 40,
    open: 6,
    unavailable: 4
  };

  const conversionData = [
    {
      value: 33,
      desc: t('state-of-hiring.candidates.conversions.conversion.contacted')
    },
    {
      value: '13%',
      desc: t('state-of-hiring.candidates.conversions.conversion.presented')
    },
    {
      value: '80%',
      desc: t('state-of-hiring.candidates.conversions.conversion.interviewed')
    },
    {
      value: '22%',
      desc: t('state-of-hiring.candidates.conversions.conversion.hired')
    }
  ];

  return (
    <StyledContainer>
      <StyledHeader>
        <Heading2 editorial>
          {t('state-of-hiring.candidates.conversions.title')}
        </Heading2>
      </StyledHeader>
      <StyledConversionsContent>
        <div>
          <HtmlTrans
            i18nKey="state-of-hiring.candidates.conversions.content"
            ns="state-of-hiring"
          />
          <StyledAvailability>
            <StyledCardTitle>
              {t('state-of-hiring.candidates.conversions.availability.title')}
            </StyledCardTitle>
            <figure>
              <StyledAvailabilityGrid>
                {[...Array(availabilityData.available)].map((index) => (
                  <div key={`available_${index}`} className="available"></div>
                ))}
                {[...Array(availabilityData.open)].map((index) => (
                  <div key={`open_${index}`} className="open"></div>
                ))}
                {[...Array(availabilityData.unavailable)].map((index) => (
                  <div
                    key={`unavailable_${index}`}
                    className="unavailable"
                  ></div>
                ))}
              </StyledAvailabilityGrid>
              <figcaption>
                <StyledLegend>
                  <div className="available"></div>
                  <span>
                    {t(
                      'state-of-hiring.candidates.conversions.availability.searching-actively'
                    )}
                  </span>
                </StyledLegend>
                <StyledLegend>
                  <div className="open"></div>
                  <span>
                    {t(
                      'state-of-hiring.candidates.conversions.availability.open-to-offers'
                    )}
                  </span>
                </StyledLegend>
                <StyledLegend>
                  <div className="unavailable"></div>
                  <span>
                    {t(
                      'state-of-hiring.candidates.conversions.availability.not-available'
                    )}
                  </span>
                </StyledLegend>
              </figcaption>
            </figure>
          </StyledAvailability>
        </div>
        <div>
          <StyledCardTitle>
            {t('state-of-hiring.candidates.conversions.conversion.title')}
          </StyledCardTitle>
          {conversionData.map((item, index) => (
            <StyledProgress key={index}>
              <StyledProgressValue>{item.value}</StyledProgressValue>
              <span>{item.desc}</span>
            </StyledProgress>
          ))}
        </div>
      </StyledConversionsContent>
    </StyledContainer>
  );
};

export default Conversions;
